<template>
  <nx-auth-card
    :title="cardTitle"
    v-on="$listeners"
  >
    <template v-if="result === 'ok'">
      <ds-text>
        {{ $t('message.login.recoverPassword.passwordRecovered') }}
      </ds-text>
      <v-btn
        block
        color="secondary"
        :to="{name: LOGIN_PAGE_NAME, params: { page: LOGIN_PAGE_ID_LOGIN }}"
        @click.prevent="redirectToLoginPage(LOGIN_PAGE_ID_LOGIN)"
      >
        {{ $t('message.login.recoverPassword.goToLogin') }}
      </v-btn>
    </template>

    <template v-else-if="result === 'recovery-token-invalid'">
      <ds-text>
        {{ $t('message.login.recoverPassword.recoveryTokenInvalid') }}
      </ds-text>
      <v-btn
        block
        color="secondary"
        :to="{name: LOGIN_PAGE_NAME, params: { page: LOGIN_PAGE_ID_FORGOT_PASSWORD }}"
        @click.prevent="redirectToLoginPage(LOGIN_PAGE_ID_FORGOT_PASSWORD)"
      >
        {{ $t('message.login.recoverPassword.goToForgotPassword') }}
      </v-btn>
    </template>

    <nx-form
      v-else
      ref="form"
      @form="form = $event"
      @submit.prevent="submit"
    >
      <ds-text>
        {{ $t('message.login.recoverPassword.description') }} {{ passwordValidationMessage }}
      </ds-text>
      <nx-form-password
        v-model="newPassword"
        name="newPassword"
        :validation="validation"
        required="true"
        :label="$t('message.form.fields.newPassword')"
        @keyup.enter.native="submit"
      />
      <v-btn
        type="submit"
        :disabled="form.invalid || form.pristine"
        color="secondary"
        block
        :loading="loading"
      >
        {{ $t('message.login.recoverPassword.recoverPassword') }}
      </v-btn>
    </nx-form>
  </nx-auth-card>
</template>

<script>
import NxForm from '@/modules/form/Form.vue';
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import NxFormPassword from '@/modules/form/components/FormPassword.vue';
import {
  LOGIN_PAGE_ID_FORGOT_PASSWORD,
  LOGIN_PAGE_ID_LOGIN,
  LOGIN_PAGE_NAME,
} from '@/modules/authentication/config/login-routes';
import AuthComponent from '@/modules/authentication/mixins/auth-component';
import PasswordValidationMessage from '@/modules/authentication/mixins/password-validation-message';

export default {
  name: 'NxAuthRecoverPassword',
  components: {
    NxFormPassword,
    NxAuthCard,
    NxForm,
  },
  mixins: [AuthComponent, PasswordValidationMessage],
  props: {
    jwt: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newPassword: '',
      form: {},
      result: null,
      LOGIN_PAGE_ID_LOGIN,
      LOGIN_PAGE_ID_FORGOT_PASSWORD,
      LOGIN_PAGE_NAME,
    };
  },
  computed: {
    cardTitle() {
      switch (this.result) {
        case 'ok':
          return this.$t('message.login.recoverPassword.recoveredTitle');
        case 'recovery-token-invalid':
          return this.$t('message.login.recoverPassword.recoveryTokenInvalidTitle');
        default:
          return this.$t('message.login.recoverPassword.title');
      }
    },
  },
  mounted() {
    if (!this.$store.getters.staffPasswordRecoveryEnabled) {
      this.redirectToLoginPage(LOGIN_PAGE_ID_LOGIN);
    }
  },
  methods: {
    async submit() {
      if (this.loading
        || this.result
      ) {
        return;
      }

      const result = await this.dispatch('authentication/RECOVER_PASSWORD', {
        jwt: this.jwt,
        newPassword: this.newPassword,
      });
      this.result = result.apiCode;

      if (!result.success) {
        this.$refs.form.errors.add({
          field: 'newPassword',
          msg: this.$t('message.login.invalidPassword'),
        });
      }
    },
  },
};
</script>
